// src/pages/SignedOut.jsx
import { useNavigate } from "react-router-dom";

// import logo from "infauxtech_logo_rectangle.png"; // adjust path if needed

export default function SignedOut() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <img
          src="infauxtech_logo_rectangle.png"
          alt="Media Forensics Hub"
          className="w-40 mx-auto mb-6"
        />

        <h2 className="text-2xl font-bold text-purple-800 mb-2">
          You’ve signed out
        </h2>
        <p className="text-gray-600 mb-6">
          You can safely close this tab, or sign in again to continue.
        </p>

        <button
          onClick={() => navigate("/login")}
          className="w-full bg-purple-700 text-white font-semibold py-2 rounded-lg hover:bg-purple-800 transition"
        >
          Sign in again
        </button>


      </div>
    </div>
  );
}
